export const modalNames = {
  settingsModal: 'settingsModal',
  chatMediaPreview: 'chatMediaPreview',
};
